import React, { Component } from 'react';
import Products from '../../Products/Products';

export default class StepSelectProduct extends Component {
    render() {
        return (
            <div className="fullheight">
                <Products onProductSelected={this.props.onProductSelected} />
            </div>
        );
    }
}
